<!--专家达人-->
<template>
  <div>
    <el-row>
      <el-col :span="4"><div class="grid-content"></div></el-col>
      <!--面包屑-->
      <el-col :span="16">
        <div class="grid-content">
          <el-breadcrumb class='crumbs' separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">专家达人</a></el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row>
      <el-col :span="4"><div class="grid-content1"></div></el-col>
      <el-col :span="16">
        <!-- tabs选项卡-->
        <div class="grid-content1">
          <el-tabs :tab-position="tabPosition" @tab-click="jump"  v-model='activeName'>
            <el-tab-pane :label="item.name" :name="item.stringId" v-for="item in tableListData" :key="item.stringId">
              <h2>{{item.name}}</h2>
              <ul class='content' v-for="item1 in newsListData" :key="item1.stringId" @click="details(item1)">
                <a><li class='title'>
<!--                  <el-image class="small"-->
<!--                            v-if="item1.homeImage != null"-->
<!--                            :src="item1.imageUrl"-->
<!--                  />-->
                  <div class="block" v-for="fit in fits" :key="fit">
                    <el-image class="smallNew"
                              v-if="item1.homeImage != null"
                              :src="item1.imageUrl"
                    />
                    </div>
                  <p>{{item1.title}}</p>
                </li></a>
              </ul>
              <!--分页-->
              <el-pagination  class="pagination"
                              v-show="total>0"
                              :total="total"
                              :current-page.sync="queryParams.pageNum"
                              :page-size.sync="queryParams.pageSize"
                              @current-change="getHomeResearchNews"
              >
              </el-pagination>

            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content1"></div></el-col>
    </el-row>
  </div>
</template>

<script>
import {homeNewsExpert, homeResearchNews, informationList} from '@/api/auth'

export default {
  activated() {
    this.getList();
  },
  data () {
    return {
      fits: ['cover'],
      tabPosition: 'left',
      tableListData: [],
      newsListData: [],
      subtitle:'',
      queryParams:{
      },
      // 总条数
      total: 0,
      queryNewsParams:{
        pageNum: 1,
        pageSize: 10,
        type:'9',
        category:'1'
      },
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
    }
  },
  methods: {
    getList() {
      let that = this;
      homeNewsExpert(this.queryParams).then(res => {
        that.tableListData = res.data.categories;
        that.total = res.data.newsContentVoIPage.total;
        res.data.newsContentVoIPage.records.forEach((value,index)=>{
          value.imageUrl=that.$baseUrl + "/upload/loadFileStreamByPath?path="+encodeURIComponent(value.homeImage)
        })
        that.newsListData = res.data.newsContentVoIPage.records;
        that.activeName = that.tableListData[0].stringId;
      })
    },
    getHomeResearchNews() {
      let that = this;
      homeResearchNews(this.queryNewsParams).then(res => {
        that.total = res.data.total;
        res.data.records.forEach((value,index)=>{
          value.imageUrl=that.$baseUrl + "/upload/loadFileStreamByPath?path="+encodeURIComponent(value.homeImage)
        })
        that.newsListData = res.data.records;
      })
    },
    jump(tab, event) {
      this.subtitle = tab.label;
      if (this.subtitle != '专家达人') {
        this.queryNewsParams.category = '2';
      } else {
        this.queryNewsParams.category = '1';
      }
      this.queryNewsParams.type = tab.name;
      this.getHomeResearchNews();
    },
    details(raw) {
      this.$router.push({
        path: '/textContent',
        query: {
          id: raw.id,
        },
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-row {
  padding-bottom: 20px;
  background-color: #eee;
  &:last-child {
    margin-bottom: 0;
  }
}
.pagination {
  margin-left: 50px;
  margin-top: 20px;
  margin-bottom: 50px;
}
.grid-content {
  height: 50px;
  //面包屑
  .crumbs{
    line-height:50px;
    font-size: 16px;
    text-indent: 10px;
    background-color: #fff;
    margin-top: 20px;
  }
}
::v-deep .el-tabs__content{
  padding-bottom: 20px;
  background-color: #fff;
}
.grid-content1 {
  min-height: 100px;
  h2{
    height: 50px;
    width: 100%;
    background-color: #fff;
    font-size: 16px;
    font-family: " 黑体";
    font-weight: bold;
    line-height: 50px;
    padding-left: 30px;
    color: #333;
  }
  .content{
    padding: 0 15px;
    background-color: #fff;
    .title{
      width: 20%;
      display: block;
      float: left;
      p{
        width: 100%;
        text-align: center;
        height: 35px;
        line-height: 35px;
        display: block;
        color: #333;
        font-family: " 黑体";
        font-size: 14px;
      }
    }
    .block{
      padding: 0 15px;
      height: 240px;
      .img{
        height: 240px;
      }
    }
  }
}
//分页
.pagination{
  width: 100%;
  margin-top: 15px;
  text-align: right;
  float: right;
}
//tabs选项卡
::v-deep .el-tabs{
  background-color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left{
  text-align: center;
  height:46px;
  width: 280px;
  font-family: Tahoma;
  font-size: 14px;
  color: #333;
  background-color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left:hover{
  background-color: #6aa84f;
  color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left:focus{
  background-color: #6aa84f;
  color: #fff;
}
// 默认选中的样式
::v-deep .el-tabs--left .el-tabs__item.is-active {
  background-color: #6aa84f;
  color: #fff;
}
.smallNew {
  width: 100%;
  height: 100%;
  position: relative;

}
.smallNew:hover {
  width: 100%;
  height: 100%;
  transform:scale(1.1); //图片按照比例，整体放大了1.2倍
  // 当鼠标经过是图片放大的倍数为1.2倍
}
</style>
